import { Environment, Sphere } from "@react-three/drei";
import { Gradient, LayerMaterial } from "lamina";
import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

import * as THREE from "three";

export const Background = () => {

  const ref = useRef()

  

  return (
    <>
      <Sphere ref={ref} scale={[300, 300, 300]} rotation-y={Math.PI / 2}>
        <LayerMaterial
          color={"#ffffff"}
          lighting="physical"
          transmission={1}
          side={THREE.BackSide}
        >
          <Gradient
            colorA={"#5BBCFF"}
            colorB={"white"}
            axes={"y"}
            start={-0.1}
            end={-0.6}
          />
        </LayerMaterial>
      </Sphere>
    </>
  );
};